import Typography from "@mui/material/Typography";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import _ from "lodash";
import InfoCard from "./InfoCard";
import InfoCardTitle from "./InfoCardTitle";
import * as React from "react";

// const farmerData = [
//   { title: "Farmer Name", description: "Mr. Ramesh Patil" },
//   { title: "Product", description: `Pomegranate` },
//   { title: "Variety Grown", description: `Bhagwa` },
//   { title: "Growing Since", description: `2017` },
//   { title: "Other Crops", description: `None` },
// ];
export default function MyFarmer({ farmerData }) {
  const titleMapping = {
    productCode: "Product Code",
    crop: "Crop",
    farmerName: "Farmer Name",
    location: "Location",
    state: "State",
    country: "Country",
    growingSince: "Growing Since",
    variety: "Variety",
    otherCrops: "Other Crops",
    sequenceNumber: "Sequence Number",
  };
  let farmerInfo = [];
  _.forEach(farmerData, (farmerDatum, key) => {
    if (farmerDatum && key !== "sequenceNumber") {
      farmerInfo.push({ title: key, description: farmerDatum });
    }
  });

  return (
    <Box sx={{ marginTop: 1 }} id={`my-farmer`}>
      <Box sx={{ textAlign: "center" }}>
        <img
          src={`/MeetMyFarmerText.jpg`}
          alt={`Meet My Farmer`}
          width={300}
          height={76}
        />
      </Box>

      <InfoCard>
        {farmerData["farmerName"] && (
          <InfoCardTitle
            image={
              <img src={`/MyFarmer.png`} alt={``} height={50} width={50} />
            }
            content={
              <Typography
                variant={`body1`}
                fontWeight={700}
                textAlign={`start`}
              >
                {farmerData["farmerName"]}
              </Typography>
            }
          />
        )}

        <TableContainer component={`div`} sx={{ textAlign: "center", mt: 1 }}>
          <Table
            aria-label="simple table"
            size={`small`}
            sx={{ border: "none" }}
          >
            <TableBody>
              {_.map(farmerInfo, (farmerDatum, index) =>
                titleMapping[farmerDatum.title] !== "Farmer Name" ? (
                  <TableRow sx={{ border: "none" }}>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ borderBottom: "none", verticalAlign: "top" }}
                    >
                      <Typography variant={`caption`}>
                        {titleMapping[farmerDatum.title]}
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{ borderBottom: "none", verticalAlign: "top" }}
                    >
                      {farmerDatum.description?.includes(",") ? (
                        farmerDatum.description
                          .split(",")
                          .map((item, index) => {
                            return (
                              <Typography variant={`caption`} key={index}>
                                - {item}
                                <br />
                              </Typography>
                            );
                          })
                      ) : (
                        <Typography variant={`caption`}>
                          - {farmerDatum.description}
                        </Typography>
                      )}
                    </TableCell>
                  </TableRow>
                ) : (
                  <></>
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </InfoCard>
    </Box>
  );
}
